module.exports = __webpack_public_path__ + "img/24-2.49976eca.png";